/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useTheme } from '@mui/material/styles';

type ImageWrapperProps = {
  src: string | [string, string];
  preset?: string;
};

const imgCss = css`
  max-width: 100%;
  max-height: 100%;
`;

const welcomeLogo = css`
  width: 250px;
  height: auto;
`;

const onboarding = css`
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const dummyData = css`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 200px;
  }
  margin-bottom: 16px;
`;

const presetCsss = {
  welcomeLogo,
  onboarding,
  dummyData,
};

function ImageWrapper({ src, preset }: ImageWrapperProps): JSX.Element {
  const theme = useTheme();

  let imageSrc = '';
  if (typeof src === 'string') {
    imageSrc = src;
  } else {
    if (theme.palette.mode === 'dark') {
      imageSrc = src[0];
    } else {
      imageSrc = src[1];
    }
    // console.log(theme);
  }

  const presetCss = preset && presetCsss[preset];

  return (
    <div css={presetCss}>
      <img css={imgCss} src={imageSrc} />
    </div>
  );
}

export default ImageWrapper;
